module.exports = __webpack_public_path__ + "static/monei_pay_starbucks_3_en-18c926d02005b3bf165e2c029ba1f3f3.png";